/// <reference path="../../../../WebUI/typings/tsd.d.ts" />

import * as React from "react";
import * as ReactDOM from "react-dom";
import {ControllerBase} from "./ControllerBase";
import { DevPortalAppBase } from "../../DevPortalAppBase";
import * as Rest from "../../Generated/RestClient";
import * as Views from "../Views/BotCreateSwitch";
import {clientAppSettings} from "../../Models/ClientAppSettings";
import {BotTypes} from "../../Utils/BotUtils";
import { Environment } from "../../Utils/Environment";
import {AbsCodeChoicePanel, AbsCodeChoiceState, AbsCodeChoiceProps, AbsCodeChoice} from "../Views/AbsCodeChoicePanel";
import {InputDialogBase} from "../../Dialogs/InputDialogBase";
import openTab from "../Services/openTab";
import {getAzurePortalBladeUrl, BladeType} from "../Services/azurePortalLinks";
import { HeaderKind } from "../Utility/HeaderKind";

export class BotCreateSwitchController extends ControllerBase {
    private component: React.Component<Views.BotCreateSwitchProps, Views.BotCreateSwitchState>;

    constructor(public app: DevPortalAppBase) {
        super(app, HeaderKind.Jumbo);
    }

    public render(params: SimpleMvc.QueryParams): void {
        super.render(params);
        var element = React.createElement(Views.BotCreateSwitch, {
            showAbsGACreate: clientAppSettings.flightedFeatures.indexOf("absGACreate") >= 0,
            onCreate: botType => this.createBot(botType),
            createFirstBot: params['createFirstBot']
        });
        this.component = ReactDOM.render<Views.BotCreateSwitchProps, Views.BotCreateSwitch>(element, this.pageContent);
    }

    private promptAbsCodeChoice(): JQueryPromise<AbsCodeChoiceState> {
        const showDialog = clientAppSettings.flightedFeatures.indexOf('absCode') >= 0;
        if (showDialog) {
            let dialog = new InputDialogBase<AbsCodeChoiceProps, AbsCodeChoiceState>(AbsCodeChoicePanel, {},
                { dialogClass: 'status-panel-dialog' });
            return dialog.showDialog();
        } else {
            return $.Deferred().resolve({choice: 'register'});
        }
    }

    private createAbsCodeBot(choice: AbsCodeChoice) {
        switch (choice) {
        case 'register':
            this.app.navigate('/bots/new');
            break;
        case 'host-in-azure':
            openTab(getAzurePortalBladeUrl(null, null, BladeType.createAbs));
            break;
        }
    }

    private createBot(botType: BotTypes) {
        switch (botType) {
            case BotTypes.None:
                this.promptAbsCodeChoice().then(choiceState => {
                    this.createAbsCodeBot(choiceState.choice);
                });
                break;
            case BotTypes.SDK:
                window.open('//aka.ms/bf-createsdkbot', '_blank');
                break;
            case BotTypes.ABSGACreate:
                window.open(Environment.azureCreateBotUrl(), "_blank");
                break;
            default:
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Controllers/BotCreateSwitchController.ts